import { VuexModule, Module, Action, Mutation, getModule } from "vuex-module-decorators";
import { login, logout, getUserInfo } from "@/api/users";
import { getToken, setToken, removeToken } from "@/utils/cookies";
import store from "@/store";
import {createHash} from "crypto";
import request from "@/utils/request";

export interface IUserState {
  token: string
  name: string
  avatar: string
  introduction: string
  roles: string[]
}

@Module({ dynamic: true, store, name: "user" })
class User extends VuexModule implements IUserState {
  public token = getToken() || "";
  public name = "";
  public avatar = "";
  public introduction = "";
  public roles: string[] = [];
  public phone: string = "";
  public isAdmin: boolean = false;

  @Mutation
  private SET_TOKEN(token: string) {
      this.token = token;
  }

  @Mutation
  private SET_NAME(name: string) {
      this.name = name;
  }

  @Mutation
  private SET_AVATAR(avatar: string) {
      this.avatar = avatar;
  }

  @Mutation
  private SET_PHONE(phone: string) {
      this.phone = phone;
  }

  @Mutation
  private SET_INTRODUCTION(introduction: string) {
      this.introduction = introduction;
  }

  @Mutation
  private SET_ROLES(roles: string[]) {
      this.roles = roles;
      for (let i = 0; i < roles.length; i++) {
          if (roles[i] === "admin") {
              this.isAdmin = true;
              break;
          }
      }
  }

  @Action
  public async Login(userInfo: { username: string, password: string }) {
      let { username, password } = userInfo;
      // eslint-disable-next-line camelcase
      let user_name = username.trim();
      password = createHash("MD5").update(password).digest("hex");
      let data = await login({ user_name, password });
      // setToken(data.accessToken);
      let token = getToken();
      if (token) {
          this.SET_TOKEN(token);
      }
      return data;
  }

  @Action
  public async Verify(verify_code: string) {
      return request({
          url: "/check_verify_code",
          method: "post",
          data: {
              verify_code: verify_code
          }
      });
  }

  @Action
  public ResetToken() {
      removeToken();
      this.SET_TOKEN("");
      this.SET_ROLES([]);
  }

  @Action
  public async GetUserInfo() {
      if (this.token === "") {
          throw Error("GetUserInfo: token is undefined!");
      }
      const { data } = await getUserInfo({ /* Your params here */ });
      if (!data) {
          throw Error("Verification failed, please Login again.");
      }
      const { role, user_name, phone } = data["info"];
      // roles must be a non-empty array
      let roles = [];
      if (role === 0) {
          roles.push("user");
      } else if (role === 1) {
          roles.push("admin");
      }
      if (!roles || roles.length <= 0) {
          throw Error("GetUserInfo: roles must be a non-null array!");
      }
      this.SET_ROLES(roles);
      this.SET_NAME(user_name);
      this.SET_PHONE(phone);
      this.SET_AVATAR("/img/icons/apple-touch-icon.png");
      // this.SET_INTRODUCTION(introduction);
  }

  @Action
  public async LogOut() {
      if (this.token === "") {
          throw Error("LogOut: token is undefined!");
      }
      await logout();
      removeToken();
      this.SET_TOKEN("");
      this.SET_ROLES([]);
  }
}

export const UserModule = getModule(User);
